import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
  const { token, loading, userRole } = useAuth();
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  if (!token) {
    return <Navigate to="/login" />;
  }
  
  // Check if the path matches the user role
  const path = window.location.pathname;
  if (
    (path.startsWith('/recruiter') && userRole !== 'recruiter') ||
    (path.startsWith('/university') && userRole !== 'universitypartner') ||
    (!path.startsWith('/recruiter') && !path.startsWith('/university') && userRole !== 'user')
  ) {
    // Redirect to the appropriate dashboard based on role
    if (userRole === 'recruiter') {
      return <Navigate to="/recruiter/dashboard" />;
    } else if (userRole === 'universitypartner') {
      return <Navigate to="/university/dashboard" />;
    } else {
      return <Navigate to="/dashboard" />;
    }
  }
  
  return children;
};

export default PrivateRoute;
